import headerAvatarView from './headerAvatarView.html';
import './headerAvatarStyles.css';

export default function headerAvatarComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {},
		controllerAs: 'vm',
		controller: headerAvatarComponentCtrl,
		template: headerAvatarView,
	};
}

class headerAvatarComponentCtrl {
	constructor(Identity, Cfg) {
		'ngInject';
		this.user = Identity.user();
		this.Cfg = Cfg;
		this.userNavOpen = false;
		this.showNotifications = parseInt(this.Cfg.read('Features.show_notifications'), 10) === 1;
	}
}
